// extracted by mini-css-extract-plugin
module.exports = {"root":"StatisticsSection_root__sdxke","title":"StatisticsSection_title__3p7OX","note":"StatisticsSection_note__1u7wX","anchorElem":"StatisticsSection_anchorElem__10urj"};